import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DocumentState } from '../entity-document-tree/state/document.state';
import * as documentActions from '../entity-document-tree/state/document.action';
import * as fromDocument from '../entity-document-tree/state/document.reducer';
import { filter, map } from 'rxjs/operators';
import Utilities from '../utilities/utilities.service';
import { DocumentViewerConfiguration } from '../models/document-viewer-configuration.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-lay-out',
  templateUrl: './lay-out.component.html',
  styleUrls: ['./lay-out.component.scss']
})
export class LayOutComponent implements OnInit {
  config$: Observable<DocumentViewerConfiguration>;

  constructor(protected store: Store<DocumentState>, private titleService: Title) { }

  ngOnInit(): void {
    // Dispatch action to load site logo image
    this.store.dispatch(new documentActions.loadDocumentViewerConfiguration());

    this.config$ = this.store.pipe(
      select(fromDocument.getDocumentViewerConfiguration),
      filter(config => !Utilities.isNullOrEmpty(config)),
      map(config => {
        // Set the page title using the site name from the configuration
        if (config.title) {
          this.titleService.setTitle(config.title);
        }
        return config;
      })
    );
  }

}
